import { b as __assign } from '../../../../tslib.es6-fe064bda.js';
import React__default, { memo } from 'react';
import { LogoLoader } from '../logo/index.js';
import { Progress } from '../progress/index.js';
import { Provider } from '../provider/index.js';
import { LoaderContent } from '../loader-content/index.js';

var LoadingComp = function (_a) {
    var logo = _a.logo, providerLogo = _a.providerLogo, progress = _a.progress, withoutProviderRenderer = _a.withoutProviderRenderer, withoutProgressRenderer = _a.withoutProgressRenderer;
    return (React__default.createElement(LoaderContent, __assign({}, {
        providerRenderer: withoutProviderRenderer ? null : React__default.createElement(Provider, { providerLogo: providerLogo }),
        progressRenderer: withoutProgressRenderer ? null : React__default.createElement(Progress, { progress: progress }),
    }, { logoRenderer: React__default.createElement(LogoLoader, { src: logo }) })));
};
LoadingComp.displayName = 'Loading';
var Loading = memo(LoadingComp);

export { Loading };
